import React from 'react';
import { Link } from 'react-router-dom';

import Styles from './SauceLogo.styles';

const SauceLogo = () => (
  <h1 className={Styles.default}>
    <Link to="/">Sauce Labs</Link>
  </h1>
);

export default SauceLogo;
